import customAxios from "../index";

export const bulkUploadProviderRegistrations = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return customAxios({
    method: "POST",
    url: "/bulk-upload/providers/register",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkUploadProviderServices = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return customAxios({
    method: "POST",
    url: "/bulk-upload/providers/services/onboard",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkUploadServices = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return customAxios({
    method: "POST",
    url: "/bulk-upload/services/seed",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkUploadSubServices = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return customAxios({
    method: "POST",
    url: "/bulk-upload/sub-services/seed",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkUploadMerchandises = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return customAxios({
    method: "POST",
    url: "/bulk-upload/merchandises/seed",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkUploadPlanners = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return customAxios({
    method: "POST",
    url: "/bulk-upload/planners/onboard",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getBulkUploadActivities = (params: {
  page: number;
  limit: number;
  fromDate?: string;
  toDate?: string;
  timezone?: string;
  uploadType?: string;
  status?: string;
}) => {
  return customAxios({
    method: "GET",
    url: "/bulk-upload/activity",
    params,
  });
};

